import joinClasses from "helpers/joinClasses";

export default function Button({ className, children, onClick, ...props }) {
  return (
    <button
      className={joinClasses(
        "font-futura-book cursor-pointer tracking-[3px] md:tracking-[4px] px-10 py-3 hover:tracking-[2px] transition-all duration-200",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}
